import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Lock, Globe } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
import { useCurrency } from '../hooks/useCurrency';
export function OfferSection() {
  const {
    price,
    currency,
    loading
  } = useCurrency();
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section id="offer" className="py-10 md:py-32 bg-maternal-cream relative overflow-hidden" data-id="element-118">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-maternal-amber via-maternal-orange to-maternal-gold" data-id="element-119"></div>
      <div className="absolute -left-32 -bottom-32 w-96 h-96 bg-maternal-amber/10 rounded-full blur-3xl" data-id="element-120"></div>
      <div className="absolute -right-32 -top-32 w-96 h-96 bg-maternal-orange/10 rounded-full blur-3xl" data-id="element-121"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-maternal-amber/30 p-6 md:p-12 text-center" data-id="element-123">
          <h2 className="text-3xl md:text-5xl font-bold text-maternal-brown mb-6" data-id="element-124">
            Recupera la paz en tu hogar hoy mismo
          </h2>

          <p className="text-lg md:text-xl text-maternal-lightBrown mb-8 max-w-2xl mx-auto" data-id="element-125">
            Por menos de lo que cuesta una salida a comer, puedes tener la hoja
            de ruta exacta que salvará la relación con tu hijo.
          </p>

          <div className="mb-10" data-id="element-126">
            <span className="text-sm font-bold uppercase tracking-wider text-maternal-orange mb-2 block" data-id="element-127">
              Precio Exclusivo
            </span>
            <div className="flex items-center justify-center" data-id="element-128">
              {loading ? <span className="text-5xl md:text-7xl font-bold text-maternal-brown animate-pulse" data-id="element-129">
                  ...
                </span> : <>
                  <span className="text-5xl md:text-7xl font-bold text-maternal-brown" data-id="element-130">
                    ${price}
                  </span>
                  <span className="text-xl md:text-2xl text-maternal-lightBrown ml-2 mt-4" data-id="element-131">
                    {currency}
                  </span>
                </>}
            </div>
            {currency !== 'ARS' && !loading && <div className="flex items-center justify-center mt-2 text-sm text-maternal-lightBrown/70" data-id="element-132">
                <Globe className="w-3.5 h-3.5 mr-1" data-id="element-133" />
                <span data-id="element-134">Precio convertido automáticamente a tu moneda local</span>
              </div>}
          </div>

          <div className="mb-8" data-id="element-135">
            <CTAButton className="text-lg md:text-xl py-5 px-10 w-full md:w-auto" href="https://checkout.ilumente.online/cart/52116586987842:1" onClick={handleBuyClick} data-id="element-136" />
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-sm text-maternal-lightBrown bg-maternal-beige/50 p-4 rounded-xl" data-id="element-137">
            <div className="flex items-center" data-id="element-138">
              <Lock className="w-5 h-5 text-green-600 mr-2" data-id="element-139" />
              <span data-id="element-140">Compra 100% segura</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-maternal-amber rounded-full" data-id="element-141"></div>
            <div className="flex items-center" data-id="element-142">
              <Zap className="w-5 h-5 text-maternal-orange mr-2" data-id="element-143" />
              <span data-id="element-144">Acceso inmediato 24/7</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-maternal-amber rounded-full" data-id="element-145"></div>
            <div className="flex items-center" data-id="element-146">
              <ShieldCheck className="w-5 h-5 text-blue-600 mr-2" data-id="element-147" />
              <span data-id="element-148">Garantía de satisfacción</span>
            </div>
          </div>

          <p className="mt-6 text-sm text-maternal-lightBrown/70 italic" data-id="element-149">
            * Acceso inmediato a todo el material, incluso si son las 3 de la
            mañana.
          </p>
        </motion.div>
      </div>
    </section>;
}